export default __webpack_public_path__ + "static/media/robot_fly.83d8c0fc.gif";